import { useEffect } from "react";

/**
 * useIdleSignOut calls onIdle once nobody has touched this tab (pointer,
 * keys, scroll, touch) for `minutes`. Other open tabs of SVENEX count as
 * activity, so working in one tab doesn't sign out the others.
 */
export function useIdleSignOut(minutes: number | null | undefined, onIdle: () => void) {
  useEffect(() => {
    if (!minutes || minutes <= 0) return;
    const KEY = "svx-last-active";
    let last = Date.now();
    const touch = () => {
      const now = Date.now();
      if (now - last < 5000) return; // at most every few seconds
      last = now;
      try { localStorage.setItem(KEY, String(now)); } catch { /* storage may be off */ }
    };
    const shared = () => { try { return Number(localStorage.getItem(KEY) || 0); } catch { return 0; } };
    const events = ["pointerdown", "keydown", "wheel", "touchstart", "scroll"] as const;
    events.forEach((e) => window.addEventListener(e, touch, { passive: true }));
    const t = window.setInterval(() => {
      if (Date.now() - Math.max(last, shared()) > minutes * 60_000) {
        window.clearInterval(t);
        onIdle();
      }
    }, 20_000);
    return () => { window.clearInterval(t); events.forEach((e) => window.removeEventListener(e, touch)); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minutes]);
}
